import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';

type ToolbarVariant = 'menu' | 'contact';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './app-toolbar.html',
  styleUrl: './app-toolbar.scss',
})
export class AppToolbar implements OnChanges {
  @Input() dark = true;
  @Input() variant: ToolbarVariant = 'menu';
  @Input() opened = false;

  isMenuOpen = signal(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['opened']) {
      this.isMenuOpen.set(this.opened);
    }
  }

  toggleMenu(): void {
    this.isMenuOpen.update((value) => !value);
  }

  closeMenu(): void {
    if (!this.isMenuOpen()) {
      return;
    }

    if (this.variant !== 'menu') {
      this.isMenuOpen.set(false);
      return;
    }

    this.isMenuOpen.set(false);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeMenu();
  }

}
